import { Routes, RouterModule } from "@angular/router";
import { NgModule, ModuleWithProviders } from "@angular/core";
import { AuthComponent } from "./auth.component";
import { LoginComponent } from "./login/login.component";

export const routes: Routes = [
  {
    path: "auth",
    component: AuthComponent,
    children: [
      { path: "", redirectTo: "/auth/login", pathMatch: "full" },
      { path: "login", loadChildren: "./login/login.module#LoginModule" },
      // { path: "forgotPassword/:id/:token", component: ForgotPasswordComponent }
    ]
  }
];

export const routing: ModuleWithProviders<RouterModule> = RouterModule.forChild(routes);
